import { Component } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { UserService } from '@services/user.service';
import { ContactUsFormComponent } from '@shared/components/contact-us-form/contact-us-form.component';
import { SecondaryFooterComponent } from '@shared/components/footer/footer.component';
import { CommonButtonComponent } from '@shared/elements/common-button/button.component';
import { ImageComponent } from '@shared/elements/image/image.component';
import { SvgIconComponent } from '@shared/elements/svg-icon/svg-icon.component';
import { checkForDiscounts, getImageLink, getParticipantsLabel } from '@shared/general';
import { SiteDetails } from '@shared/models/email.model';
import { Event } from '@shared/models/event.model';
import { Membership } from '@shared/models/membership.model';
import { displayOnlyTime, handleDateForGrid } from '@shared/time';
import { LocalStorageService } from '../../services/local-storage.service';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    CommonButtonComponent,
    SvgIconComponent,
    ImageComponent,
    ContactUsFormComponent,
    SecondaryFooterComponent,
    RouterLink,
  ],
  templateUrl: './home.component.html',
})
export class HomeComponent {
  siteDetails?: SiteDetails;
  introImage?: string;
  banner?: string;
  events: Event[] = [];
  memberships: Membership[] = [];
  showAll: boolean = false;

  constructor(
    private storage: LocalStorageService,
    public router: Router,
    private userService: UserService,
  ) {
    this.storage.toggleTheme('light');

    this.userService.getSiteInfo().subscribe((res) => {
      this.siteDetails = res.data;
      this.introImage = getImageLink(this.siteDetails?.backgroundImage?.id);
      this.banner = getImageLink(this.siteDetails?.banner?.id);
      this.storage.logoId.set(res.data.siteLogo.id);
    });

    this.userService.getActiveEvents(true, false).subscribe((res) => {
      const events = res.data.content ?? [];
      events.forEach((e) => {
        const sameDate = e.startDate === e.endDate;
        let date = handleDateForGrid(e.startDate);
        if (!sameDate) {
          let end = handleDateForGrid(e.endDate);
          date += ' - ' + end;
        }
        e.dateLabel = date;
        e.timeLabel = displayOnlyTime(e.startTime) + ' - ' + displayOnlyTime(e.endTime);
        e.participantsLabel = getParticipantsLabel(e.eventSeatsList);
        e.activeDiscounts = checkForDiscounts(e.eventSeatsList);
      });
      this.events = [...events].slice(0, 3);
    });

    this.userService.getMemberships().subscribe((res) => {
      this.memberships = res.data.content ?? [];
    });
  }

  purchaseMembership(id: number): void {
    if (this.storage.isLoggedIn()) {
      this.router.navigate(['/purchase/membership'], { queryParams: { id: id } });
    } else {
      this.router.navigate(['/login']);
    }
  }
}
